import React from 'react'
import PropTypes from 'prop-types'
import styles from './master-form.module.css'

export default class StepBusinessDetails extends React.Component {
  render() {
    return (
      <>
        <p className={styles.question}>What is your business name?</p>
        <div className={styles.formText}>
          <label htmlFor="businessName">Business Name</label>
          <input
            type="text"
            className={styles.formTextInput}
            id="businessName"
            name="businessName"
            value={this.props.businessName}
            onChange={this.props.handleChange}
          />
        </div>
        <p className={styles.subQuestion}>For example this could be the name of your Limited company or sole trading name.</p>
      </>
    )
  }
}

StepBusinessDetails.propTypes = {
  businessName: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
}